export default __webpack_public_path__ + "static/media/Movikraft.96109f7c.png";